import { gql } from '@apollo/client';

export const GlossaryFieldsFragment = gql`
  fragment GlossaryFields on Glossary {
    id
    word
    definition
  }
`;
